var map = {
	"./category.vue": "8931",
	"./cgoods.vue": "39ce",
	"./color.vue": "8686",
	"./colors.vue": "161f",
	"./editorimage.vue": "5b4d",
	"./editorswitch.vue": "d1c8",
	"./gcategory.vue": "6716",
	"./images.vue": "d491",
	"./inputnumber.vue": "17b2",
	"./list.vue": "8366",
	"./radio.vue": "3538",
	"./slider.vue": "c4a1",
	"./tab.vue": "2ba1",
	"./words.vue": "771a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6c1";